import { environment } from '../../environments/environment';

export const cancellationValues = [
  {
    value: 'refundable',
    name: 'booking-widget-refundable',
    image: `${environment.imgixHost}/website/cancellation/refundable-icon.png`
  },
  {
    value: 'non-refundable',
    name: 'booking-widget-non-refundable',
    image: `${environment.imgixHost}/website/cancellation/non-refundable-icon.png`
  }
];

export enum cancellationPolicyCodes {
  flexible = 'FLEX',
  nonRefundable = 'NONREF'
}

export const cancellationPolicyNames = {
  FLEX: 'refundable',
  NONREF: 'non-refundable'
};
